module.exports = __webpack_public_path__ + "img/icon-ad.d070a025.svg";